import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileAdminDonorData, IDonorProfileAdminLookupData } from '@nkr/models/index';

export interface IDonorProfileAdminResponse {
    data: {
        success: boolean,
        results: {
            donorData: IDonorProfileAdminDonorData,
            lookupData: IDonorProfileAdminLookupData
        }
    }
}

export const ActionCreators = {
    getProfileAdminData: (donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileAdminResponse> => {
        let options = {
            url: __API__ + `/admin/donor/${donorId}/admin-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}